import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import TitleCard from '../components/TitleCard/TitleCard';
import TermsForm from '../components/Forms/TermsForm/TermsForm';
import IntroForm from '../components/Forms/IntroForm/IntroForm';
import { RootStore } from '../store/reducers';
import buildPATHS from '../utils/paths';
import { termsActiveSelector } from '../store/selectors/termsConfigSelectors';
import {
  registerAccessSelector,
  urlParamsSelector,
} from '../store/selectors/appSelectors';
import { introSelector } from '../store/selectors/globalConfigSelectors';
import allActions from '../store/actions';
import {
  continueAsGuestSelector,
  createAccountEnabledSelector,
  loginEnabledSelector,
} from '../store/selectors/formSessionSelectors';
import { isAuthenticated } from '../utils/authService';

const Welcome: React.FC = () => {
  const {
    termsActive,
    registerAccess,
    urlParams,
    continueAsGuest,
    loginEnabled,
    createAccountEnabled,
  } = useSelector((state: RootStore) => ({
    termsActive: termsActiveSelector(state),
    registerAccess: registerAccessSelector(state),
    urlParams: urlParamsSelector(state),
    continueAsGuest: continueAsGuestSelector(state),
    loginEnabled: loginEnabledSelector(state),
    createAccountEnabled: createAccountEnabledSelector(state),
  }));

  const history = useHistory();
  const PATHS = buildPATHS();
  useEffect(() => {
    if (!urlParams) {
      history.push(PATHS.login);
    }
  }, []);

  const dispatch = useDispatch();

  const { intro } = useSelector((state: RootStore) => ({
    intro: introSelector(state),
  }));

  const isOnlyLoginEnabled = () => {
    return loginEnabled && !continueAsGuest && !createAccountEnabled;
  };

  useEffect(() => {
    if (urlParams && !termsActive && !intro.introductionText) {
      if (isOnlyLoginEnabled() && !isAuthenticated()) {
        history.push(PATHS.login);
      } else {
        dispatch(allActions.appConfigActions.setAccessToRegister(true));
        history.push(PATHS.register);
      }
    } else if (urlParams && registerAccess) {
      history.push(PATHS.register);
    }
  }, [registerAccess, history, PATHS]);

  return (
    <>
      <TitleCard />
      {urlParams ? termsActive ? <TermsForm /> : <IntroForm /> : null}
    </>
  );
};

export default Welcome;
